import NewPassword from './NewPassword.vue'

export default {
    path:'new-password',
    component:NewPassword
}